module.exports = __webpack_public_path__ + "img/icon_jornal_de_pagos.92a4db1b.svg";